// eslint-disable-next-line import/prefer-default-export
export const GetMembershipKnowYourCommunitySelector = ({
  membershipKnowYourCommunity: { GetMembershipKnowYourCommunity }
}) => GetMembershipKnowYourCommunity;

export const PostMembershipKnowYourCommunitySelector = ({
  membershipKnowYourCommunity: { PostMembershipKnowYourCommunity }
}) => PostMembershipKnowYourCommunity;
